import { BarChart3, Calendar, BookOpen, MessageSquare } from "lucide-react";
import SpotlightCard from "./SpotlightCard";

const features = [
  {
    icon: BarChart3,
    title: "One-Stop Solution",
    description:
      "Comprehensive support through courses, 1:1 sessions, and exclusive digital resources to help you secure off-campus opportunities.",
  },
  {
    icon: Calendar,
    title: "Stand Out",
    description:
      "Proven strategies that help you rise above 90% of the competition with clarity and confidence.",
  },
  {
    icon: BookOpen,
    title: "Affordable Excellence",
    description:
      "Premium guidance at prices lower than a pizza—designed for real outcomes, not fluff.",
  },
  {
    icon: MessageSquare,
    title: "Post-Session Support",
    description:
      "We're here after the session, too—get timely answers and ongoing guidance as you execute.",
  },
];

const FeatureSection = () => {
  return (
    <section
      className="relative w-full mt-32 py-16 sm:py-20 overflow-hidden"
      aria-labelledby="why-choose-us"
    >
      {/* Latest Dotted Background Pattern */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "radial-gradient(#404040 1px, transparent 1px)",
          backgroundSize: "20px 20px",
        }}
      />
      <div
        className="absolute inset-0 z-0"
        style={{
          background:
            "radial-gradient(ellipse at center, transparent 30%, black 95%)",
        }}
      />

      {/* Top and bottom fade gradients */}
      <div
        className="absolute top-0 left-0 right-0 h-32 z-[1] pointer-events-none"
        style={{
          background:
            "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0.8) 40%, transparent 100%)",
        }}
      />
      <div
        className="absolute bottom-0 left-0 right-0 h-24 z-[1] pointer-events-none"
        style={{
          background:
            "linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,0.8) 40%, transparent 100%)",
        }}
      />

      {/* Content - positioned relatively to appear above background */}
      <div className="relative z-10">
        {/* Heading */}
        <div className="flex justify-center mb-6">
          <span className="inline-flex items-center rounded-full border border-border  bg-gradient-to-r from-[#202766] via-[#08B1CF] to-[#342B8D] bg-clip-text text-transparent px-4 py-1.5 text-xs f font-bold text-foreground/80">
            WHY CHOOSE US
          </span>
        </div>

        <h2
          id="why-choose-us"
          className="text-center text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-10"
        >
          Designed to help you win off-campus
        </h2>

        {/* Inner centered wrapper */}
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {features.map((f, i) => (
              <SpotlightCard
                key={i}
                icon={f.icon}
                title={f.title}
                description={f.description}
                spotlightColor="rgba(255, 255, 255, 0.15)"
                className="h-full min-h-[170px] shadow-lg shadow-black/40"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
